import {GetStorage} from "../../../../cuppa/reactComponents/GetStorage";
import {Storages} from "../../../controllers/Storages";
import {useState} from "react";
import {log} from "../../../../cuppa/cuppa";
import {OrganizationsSelector} from "../fields/OrganizationsSelector";
import {UserInfo} from "./UserInfo";
import {Globals} from "../../../controllers/Globals";
import {Language} from "../../../controllers/Language";
import {Tooltip} from "../Tooltip";
import {CuppaTooltip} from "../../../../cuppa/components/cuppa.tooltip";

export function TopBar(props){
	const [user, setUser] = useState();
	return (
		<div className={'top-bar flex a-center d-row l-0-s1100'}>
			<GetStorage {...Storages.user} callback={setUser} />
			<div className={'flex d-row j-start a-start p-l-10-s1100'} style={{flex:1, paddingLeft:20}}>
				<button
					className={'button1 button-icon transparent m-r-5 d-none d-flex-s1100'}
					style={{width:'auto'}}
					onClick={()=>{
						Globals.menuDrawer.open();
					}}
				>
					<i className="far fa-bars "></i>
				</button>
				<OrganizationsSelector />
			</div>
			<div className={'flex s-stretch'}>
				<UserInfo />
			</div>
			<button
				className={'button1 btn-menu-collapse button-icon transparent d-none-s1100'}
				onClick={()=>document.body.classList.toggle('menu-collapsed')}
			>
				<i className="far fa-ellipsis-v"></i>
			</button>
			<Tooltip target={'.btn-menu-collapse'} text={Language.value('Collapse Menu')} posX={CuppaTooltip.POSITION.RIGHT} posY={CuppaTooltip.POSITION.CENTER} arrow={CuppaTooltip.ARROW.LEFT}  />
		</div>
	)
}
